import { userActivityRepo } from '../repo';

export const userActivityService = {
    async getAll(params = {}) {
        try {
            return await userActivityRepo.getAll(params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats(params = {}) {
        try {
            return await userActivityRepo.getStats(params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByUser(userlogId, params = {}) {
        if (!userlogId) {
            throw new Error('User log ID is required');
        }
        try {
            return await userActivityRepo.getByUser(userlogId, params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getBySubject(subjectId, params = {}) {
        if (!subjectId) {
            throw new Error('Subject ID is required');
        }
        try {
            return await userActivityRepo.getBySubject(subjectId, params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(activityId) {
        if (!activityId) {
            throw new Error('Activity ID is required');
        }
        try {
            return await userActivityRepo.getById(activityId);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('UserActivityService Error:', error);
        return error.response?.data || error;
    },
};